<div class="settings-modal-content">
  <h2 class="my-4 mat-h2">Competitors</h2>
  <div>
    <div class="flex gap-4 items-baseline mb-4">
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="newCompetitor.name" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Description</mat-label>
        <input matInput [(ngModel)]="newCompetitor.description" />
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="addCompetitor()" [disabled]="!newCompetitor.name.trim()">
        <span>Add competitor</span>
      </button>
    </div>
    <ng-container *ngIf="competitors.length === 0">
      <label>No competitors defined</label>
    </ng-container>
    <ng-container *ngIf="competitors.length > 0">
      <div *ngFor="let competitor of competitors; let i = index" class="flex gap-2 items-center mb-2">
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="competitor.name" (ngModelChange)="updateCompetitorName(i, $event)" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Description</mat-label>
          <input matInput [(ngModel)]="competitor.description" (ngModelChange)="updateCompetitorDescription(i, $event)" />
        </mat-form-field>
        <button mat-icon-button (click)="deleteCompetitor(i)" aria-label="Delete" color="error"><mat-icon>delete_forever</mat-icon></button>
      </div>
    </ng-container>
  </div>
</div>
